import React, { useState } from 'react';
import { ESTADO_CITA, Chip, fecha, hora, estilos as s } from '../comun';
import { CitaModal, PanelCita } from '../citas';

// Pestaña "Citas" del caso: las citas de orientación ligadas a este caso.
export default function CitasCaso({ caso, onCambio }) {
  const [nueva, setNueva] = useState(false);
  const [abierta, setAbierta] = useState(null);
  const editable = caso.permisos.editable;
  const ahora = new Date();
  const proximas = caso.citas.filter(c => c.estado === 'programada' && new Date(c.inicio) >= ahora).reverse();
  const resto = caso.citas.filter(c => !proximas.includes(c));

  const fila = (c) => (
    <button key={c.id} onClick={() => setAbierta(c)} style={es.fila}>
      <div style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
        <div style={es.titulo}>{c.tipo || 'Cita'}</div>
        <div style={es.meta}>
          {fecha(c.inicio)} · {hora(c.inicio)}{c.lugar ? ` · ${c.lugar}` : ''}{c.profesional ? ` · ${c.profesional}` : ''}
          {c.visible_familia ? ' · visible para la familia' : ''}
        </div>
      </div>
      {c.estado === 'programada' && new Date(c.inicio) < ahora
        ? <span style={es.sinMarcar}>Falta marcar asistencia</span>
        : <Chip def={ESTADO_CITA[c.estado]} />}
    </button>
  );

  return (
    <div>
      {editable && <button onClick={() => setNueva(true)} style={{ ...s.btnPrimario, marginBottom: '14px' }}>+ Agendar cita</button>}
      {caso.citas.length === 0 && <div style={es.vacio}>No hay citas para este caso.</div>}
      {proximas.length > 0 && (
        <>
          <h4 style={es.subtitulo}>Próximas</h4>
          <div style={es.lista}>{proximas.map(fila)}</div>
        </>
      )}
      {resto.length > 0 && (
        <>
          <h4 style={es.subtitulo}>Anteriores</h4>
          <div style={es.lista}>{resto.map(fila)}</div>
        </>
      )}

      {nueva && (
        <CitaModal casoFijo={{ id: caso.id, estudiante: caso.estudiante }} esLider={caso.permisos.es_lider}
          portalFamilia={caso.permisos.portal_familia}
          onCerrar={() => setNueva(false)} onGuardada={() => { setNueva(false); onCambio(); }} />
      )}
      {abierta && (
        <PanelCita cita={{ ...abierta, caso_id: caso.id, puede_gestionar: abierta.puede_gestionar && editable }}
          desdeCaso onCerrar={() => setAbierta(null)} onCambio={onCambio} />
      )}
    </div>
  );
}

const es = {
  subtitulo: { fontSize: '13px', fontWeight: 800, color: '#555', textTransform: 'uppercase', letterSpacing: '0.3px', margin: '6px 0 10px' },
  lista: { display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' },
  fila: { display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap', width: '100%', background: '#fff', border: '1px solid #eef0f5', borderRadius: '12px', padding: '12px 14px', cursor: 'pointer', fontFamily: 'inherit' },
  titulo: { fontSize: '14px', fontWeight: 700, color: '#1a1a2e' },
  meta: { fontSize: '12px', color: '#999', marginTop: '2px' },
  sinMarcar: { background: '#fff8e1', color: '#8a5a00', borderRadius: '999px', padding: '3px 10px', fontSize: '11.5px', fontWeight: 700 },
  vacio: { background: '#fafbff', border: '1px dashed #dde0f0', borderRadius: '12px', padding: '20px', textAlign: 'center', color: '#999', fontSize: '14px' },
};
